(()=>{const root=window.document.getElementById('stikkma-hats-v1');if(!root)return;
const resolve=window.StikkmaHatAssets.resolve,Image=window.StikkmaHatAssets.Image,fetch=window.StikkmaHatAssets.fetch;
const document=new Proxy(window.document,{get(t,p){if(p==='querySelector')return s=>root.querySelector(s);if(p==='querySelectorAll')return s=>root.querySelectorAll(s);if(p==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));const v=Reflect.get(t,p,t);return typeof v==='function'?v.bind(t):v;}});
/* Font selection card; the product engine owns the five-step flow and choices. */
(function () {
  let revision=0,textOpen=false;
  async function refresh() {
    const select=document.querySelector('#stitch-font,#font');
    const canvas=document.getElementById('font-choice-sample');
    const name=document.querySelector('#stitch-name,#name');
    if(!select||!canvas||!name)return;const clear=document.getElementById('clear-stitch-text');if(clear)clear.hidden=!name.value;
    const hasText=!!name.value.trim();
    if(hasText)textOpen=true;
    const editor=document.getElementById('text-editor');
    if(editor)editor.hidden=!textOpen;
    const choice=document.getElementById('text-choice-name');
    if(choice)choice.textContent=hasText?name.value.trim():textOpen?'Dein Text':'Ohne Text';
    const status=document.getElementById('text-choice-status');
    if(status)status.textContent=hasText?'Textstick · +5,00 €':textOpen?'Gib deinen Namen oder deine Worte ein.':'Deine Mütze bleibt\nohne Textstick.';
    const open=document.getElementById('choose-text');
    if(open){open.textContent=textOpen?'Text bearbeiten':'Text hinzufügen';open.setAttribute('aria-expanded',String(textOpen));}
    document.getElementById('remove-text')?.toggleAttribute('hidden',!textOpen);
    document.querySelectorAll('[data-requires-text]').forEach(el=>el.hidden=!hasText);
    const id=select.value,token=++revision;
    const font=window.CuscoCatalog.fonts.find(f=>f.id===id);
    document.getElementById('font-choice-name').textContent=font?.name||'Deine Stickschrift';
    canvas.setAttribute('aria-label','Stickvorschau der Schrift '+(font?.name||''));
    try {
      const sf=window.CuscoStitchFont;await sf.ready;await sf.load(id);
      if(token!==revision)return;
      sf.sample(canvas,name.value.trim()||'Aa','#ffffff',id);
    } catch {canvas.getContext('2d').clearRect(0,0,canvas.width,canvas.height);}
  }
  function init() {
    const name=document.querySelector('#stitch-name,#name');
    if(!name)return;
    document.getElementById('choose-text')?.addEventListener('click',()=>{
      textOpen=true;refresh();name.focus();
    });
    document.getElementById('remove-text')?.addEventListener('click',()=>{
      textOpen=false;name.value='';name.dispatchEvent(new Event('input',{bubbles:true}));refresh();document.getElementById('choose-text')?.focus();
    });
    document.addEventListener('input',()=>queueMicrotask(refresh));
    document.addEventListener('change',()=>queueMicrotask(refresh));
    document.addEventListener('click',event=>{
      if(event.target.closest('[data-start-embroidery],[data-try-stitch-font]'))textOpen=true;
      if(event.target.closest('[data-font],[data-pick-font],[data-start-embroidery],[data-try-stitch-font]'))queueMicrotask(refresh);
    });
    refresh();
  }
  window.StikkmaEmbroideryUI={refresh};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

})();
